import { GET_FOOTER } from '@/api/mall'

const footer = {
  state: {
    info: null
  },
  mutations: {
    footerdata (state, info) {
      state.info = info
    }
  },
  actions: {
    getfooter (context) {
      return new Promise((resolve, reject) => {
        GET_FOOTER()
          .then(({ data }) => {
            console.log('context', context)
            context.commit('footerdata', data)
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
export default footer



// WEBPACK FOOTER //
// ./src/store/modules/footer.js